<template>
  <quizTag :class="{'is-shown': showQuizzes && frame}" @submit="submit" :meta="meta" :key="meta.quiz.id" @navigate="navigate" :frame="frame" :selectedQuizIndex="quizIndex" :dimensions="dimensions" :isLastFrame="showQuizzes" />
</template>

<script>
import quizTag from './quizTag'

export default {
  name: 'quizzesTag',
  components: {
    quizTag
  },
  props: ['meta', 'frame', 'isLastFrame', "dimensions"],
  watch: {
    isLastFrame(value) {
      if (value) {
        this.videoElement.pause()
        this.showQuizzes = true
      }
    },
    'quizzes': 'initTag'
  },
  data() {
    return {
      quizIndex: 0
    }
  },
  methods: {
    initTag() {
      this.meta.quiz = this.meta.quizzes ? this.meta.quizzes[this.quizIndex] : {}
      this.showQuizzes = null
    },
    submit() {
      this.quizIndex = this.quizIndex + 1
      if (this.quizIndex <= this.meta.quizzes.length - 1) {
        this.meta.quiz = this.meta.quizzes[this.quizIndex]
        this.version = this.version + 1
      } else {
        this.$emit('hide')
        this.quizIndex = 0
        this.meta.quiz = this.meta.quizzes[this.quizIndex]
        this.videoElement.play()
      }
    },
    navigate(direction) {
      this.quizIndex = this.quizIndex + direction
      if (this.quizIndex > this.meta.quizzes.length - 1) {
        this.quizIndex = 0
      } else if (this.quizIndex < 0) {
        this.quizIndex = this.meta.quizzes.length - 1
      }
      this.meta.quiz = this.meta.quizzes[this.quizIndex]
      this.version = this.version + 1
    }
  },
  created() {
    this.$nextTick(() => {
      this.videoElement = document.getElementsByClassName('viewer-video')[0]
    })
    console.log('quizTag created', this.meta, this.dimensions)
    this.initTag()
  },
}

</script>